<template>
  <div class="modal">
    <div class="modal-content" :class="'modal-' + modalType">
      <h2 class="modal-header">Atualização</h2>
      <div class="modal-body text-center">
        <p>Uma nova versão da fatura está disponível.</p>
        <button class="button button-primary" @click="reloadPage()">
          Atualizar
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'updateModal',
  data () {
    return {

    }
  },
  methods: {
    ...mapMutations(['SET_UPDATE_MODAL']),
    closeModal () {
      this.SET_UPDATE_MODAL(false)
    },
    reloadPage () {
      window.location.reload(true)
    }
  },
  watch: {
    updateModal (value) {
      if (value) {
        document.body.classList.add('modal-opened')
      } else {
        document.body.classList.remove('modal-opened')
      }
    }
  }
}
</script>
